import type { PipeTransform } from '@angular/core';
import { Pipe, inject } from '@angular/core';

import type { BillingPlan } from '@core/billing-types';
import { I18nService } from '@core/i18n-legacy';

import { getProductCodeOrThrow } from '../../helpers/get-product-code-or-throw';
import { getProductName } from '../../helpers/get-product-name';

@Pipe({
  name: 'rtProductName',
  pure: true,
  standalone: true,
})
export class ProductNamePipe implements PipeTransform {
  private readonly i18n = inject(I18nService);

  public transform(
    productOrCodename: Pick<BillingPlan, 'tier' | 'custom'> | string,
    opts?: { short?: boolean },
  ): string {
    try {
      const codename =
        typeof productOrCodename === 'string'
          ? getProductCodeOrThrow(productOrCodename)
          : productOrCodename.tier;
      const custom = typeof productOrCodename === 'string' ? false : productOrCodename.custom;

      return getProductName({ codename, custom }, this.i18n, opts?.short);
    } catch (err) {
      return typeof productOrCodename === 'string' ? productOrCodename : productOrCodename.tier;
    }
  }
}
